<template>
<div v-if="preloadDone">
  <kendo-datasource ref="datasource1" :transport="gridTransport" :schema-model-fields="schemaModelFields" :schema-total="schemaTotal" :schema-data="'data'" :page-size='pagesize?pagesize:10' :server-paging="true" :server-filtering="true" :server-sorting="true" :page="options.dataSource.page"
    :filter="options.dataSource.filter" :sort="options.dataSource.sort">
  </kendo-datasource>
  <kendo-grid ref="mygrid" :height="height" :data-source-ref="'datasource1'" :pageable='pageable' :filterable='filterable' :sortable='sortable' :columns="columns" :scrollable="true" v-on:databound="finalDataBound">
  </kendo-grid>
</div>
</template>

<script>
import Vue from 'vue'
import kendo from '@progress/kendo-ui/js/kendo.all.js' // eslint-disable-line no-unused-vars
import {
  KendoGrid,
  KendoGridInstaller
} from '@progress/kendo-grid-vue-wrapper'
import {
  KendoDataSource,
  KendoDataSourceInstaller
} from '@progress/kendo-datasource-vue-wrapper'
// var jQuery = require('jquery')

Vue.use(KendoDataSourceInstaller)
Vue.use(KendoGridInstaller)

export default {
  props: ['name', 'schemaModelFields', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'height', 'databound', 'pagesize'],
  components: {
    KendoGrid,
    KendoDataSource
  },
  data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      finalDataBound: null,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    }
  },
  methods: {
    getTransport() {
      var v = this
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          beforeSend(req) {
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token())
          }
        }
      }
    },
    getGrid() {
      return this.$refs.mygrid.kendoWidget()
    },
    getTotal(response) {
      if (response.meta) {
        return response.meta.pagination.total
      } else {
        return response.data.length
      }
    },
    setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data
        }
      }
    }
  },
  created() {
    if (typeof this.databound === 'function') {
      this.finalDataBound = this.databound
    } else {
      this.finalDataBound = function() {}
    }
    var that = this
    if (localStorage[this.name + 'options']) {
      this.options = JSON.parse(localStorage[this.name + 'options'])
    }
    var apiPreloads = []
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api)
      }
      this.axios.all(apiPreloads.map(l => this.axios.get(l))).then(
        that.axios.spread(function() {
          for (var i = 0; i < that.preload.length; i++) {
            that.setColumnsData(arguments[i].data.data, that.preload[i].field)
          }
          that.preloadDone = true
        })
      ).catch(response => {
        console.error('error loading foreigns', response)
      })
    } else {
      that.preloadDone = true
    }
  },
  beforeDestroy() {
    try {
      var grid = this.$refs.mygrid.kendoWidget()
      localStorage[this.name + 'options'] = kendo.stringify(grid.getOptions())
    } catch (error) {}
  }
}
</script>



// WEBPACK FOOTER //
// Grid.vue?0a91e051